import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { surveillerLaVersionServie } from './app/versionServie'
import './styles/index.css'

// Avant le premier rendu : un onglet ouvert pendant un déploiement demande
// des morceaux qui n'existent plus, et l'écran reste vide (§309).
surveillerLaVersionServie()

const root = document.getElementById('root')
if (!root) throw new Error('#root introuvable')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
